import { UserContactOutSchema } from "@/api/client";
import canadaFlag from "/assets/Images/icons/flags/canada.svg";
import ukFlag from "/assets/Images/icons/flags/uk.svg";
import usFlag from "/assets/Images/icons/flags/usa.svg";
// import nigerianFlag from "/assets/Images/icons/flags/nigerian.svg";
// import kenyanFlag from "/assets/Images/icons/flags/kenya.svg";

export const PINIA_PERSIST_OPTIONS = {
  storage: localStorage,
};

//
export const AUTH_EXCLUDE_LIST = [
  "/api/login/",
  "/api/auth/token/",
  "/api/auth/token/refresh/",
  "/api/payments/subscription-plan/",
  "/api/recommendation-form/",
  "/api/users/register/",
];

export const predefinedGradients = [
  "linear-gradient(180deg, #FF8268 0%, rgba(255, 173, 156, 0.76) 100%)",
  "linear-gradient(147.58deg, #2EC97F 12.62%, rgba(0, 228, 119, 0.78) 92.01%)",
  "linear-gradient(151.34deg, #37BAD7 -7.94%, rgba(0, 209, 255, 0.79) 82.33%)",
  "linear-gradient(156.37deg, #EA61C4 4.95%, rgba(255, 165, 230, 0.82) 87.83%)",
  "linear-gradient(146.84deg, #66B9CB 9.21%, rgba(147, 235, 255, 0.8) 90.12%)",
  "linear-gradient(147.48deg, #715AFF -5.35%, rgba(186, 174, 255, 0.85) 80.53%)",
  "linear-gradient(153.43deg, #11BEAC 0%, rgba(91, 231, 217, 0.94) 83.33%)",
  "linear-gradient(160.07deg, #FF5A78 3.66%, rgba(255, 180, 194, 0.91) 86.7%)",
];

// Api switch
const currentRoute = window.location.host;
export const STAGING_BASE_API = "https://gaia-api.staging.cloud.pressone.co";
export const INTERNAL_LIVE_BASE_API =
  "https://pressone-internal-live.herokuapp.com";
export const PRODUCTION_BASE_API = "https://api.pressone.co";

export const TELEPHONY_BASE_API = "https://telephony.api.pressone.co";

export const IS_PROD = currentRoute === "web.pressone.africa";

export const IS_STAGING =
  currentRoute === "agent-portal.staging.cloud.pressone.co";

export const BASE_API =
  localStorage.getItem("baseUrl") ??
  (IS_PROD ? PRODUCTION_BASE_API : STAGING_BASE_API);

export const IS_PROD_BASEURL = BASE_API === PRODUCTION_BASE_API;
export const IS_STAGING_BASE_URL =
  (localStorage.getItem("baseUrl") || BASE_API) === STAGING_BASE_API;

export const IS_INTERNAL = BASE_API === INTERNAL_LIVE_BASE_API;

export const ENVIRONMENT_OPTIONS = [
  { label: "Staging", key: "staging", value: STAGING_BASE_API },
  {
    label: "Deprecated[Internal Live]",
    key: "internal_live",
    value: INTERNAL_LIVE_BASE_API,
  },
  { label: "Production", key: "production", value: PRODUCTION_BASE_API },
];

// Engage analytics
export const ENGAGE_PUBLIC_KEY = "04c36dc3bf6d142c7e31c4bd2bd04d6b";
export const ENGAGE_PRIVATE_KEY = "2213c498f11fb08c7177f33060ec4056";

// Digital Ocean Credentials
export const DIGITAL_OCEAN_ACCESS_KEY = "DO00XDHCEU47RHMX32V8";
export const DIGITAL_OCEAN_SECRET_ACCESS_KEY =
  "BIIypGteKinUoIgwyQKjLuoINx1w38/P6vSr/oePkpk";
export const DIGITAL_OCEAN_REGION = "fra1";
export const DIGITAL_OCEAN_ENDPOINT = "https://fra1.digitaloceanspaces.com";
export const STAGING_DIGITAL_OCEAN_BUCKET = "pressone-staging";
export const PROD_DIGITAL_OCEAN_BUCKET = "pressone-prod";

// Google Recaptcha Credente
const STAGING_RECAPTCHA_SITE_KEY = "6LfE-XgqAAAAANgdCikEjf1BR-bmNm9OEHMIub3t";
const PROD_RECAPTCHA_SITE_KEY = "6LfDuXgqAAAAANnGfonlqsm4StiReALoisXLD1gC";
export const RECAPTCHA_SITE_KEY = IS_PROD
  ? PROD_RECAPTCHA_SITE_KEY
  : STAGING_RECAPTCHA_SITE_KEY;

export const STAGING_SENTRY_DSN =
  "https://10a6cf585b855e6c2d0f89a2aaa8018f@o1125524.ingest.us.sentry.io/4508487816183808";
export const PROD_SENTRY_DSN =
  "https://0ceb1349d55bc6e784086af2e2de8562@o1125524.ingest.us.sentry.io/4506931959955456";
export const STAGING_PAYSTACK_PUBLIC_KEY =
  "pk_test_8093a8147fb2f2bc941c8c466a49971ea2e1377b";
export const QA_PAYSTACK_PUBLIC_KEY =
  "pk_test_cc3e0a64a5ecfee94230e15059beabba4bab0696";
export const PROD_PAYSTACK_PUBLIC_KEY =
  "pk_live_e652300a25113ac68492950e7696cae1a8cbb521";

export const PAYSTACK_KEY =
  BASE_API === PRODUCTION_BASE_API
    ? PROD_PAYSTACK_PUBLIC_KEY
    : localStorage.getItem("baseUrl")?.includes("qa")
      ? QA_PAYSTACK_PUBLIC_KEY
      : STAGING_PAYSTACK_PUBLIC_KEY;

export const publicPages = [
  "/sign-in",
  "/sign-up",
  "/otp",
  "/forgot-password",
  "/verify-email/new",
  "/verify-email/existing",
  "/verify-email",
  "/verify-signin-token",
  "/email-verification",
  "/reset/email-verification",
  "/reset-password",
  "/complete-signup",
  "/agent/signup",
  "/affiliate",
  "/welcome",
  "/plan-selection",
  "/business-setup",
  "/join-conversation",
  "/guest-conversation",
  "/verify-nin",
  "/payment-successful",
  "/additional-slot",
  "/pending-invites",
  "/address-purchase",
];

// This are the allowed route that a freetrial user can access
export const freeTrialRoutes = [
  "/welcome",
  "/add-on/free-live-call",
  "/add-on/live-call-free-widget/register-website",
  "/add-on/live-call-free-widget/welcome",
  "/add-on/live-call-free-widget/upgrade-subscription",
  "/managers/provision-number",
  "/managers/add-ons/live-call-widget",
  "/managers/profile-update",
  "/developers/dashboard",
  "/developers/profile-update",
  "/developers/live-call-free-widget/upgrade-subscription",
  "/developers/live-call-widget",
  "/developers/voice-otp",
  "/developers/connection",
  "/add-on/live-call-free-widget/upgrade-subscription",
  "/managers/provision-number", // can access this when user wants to upgrade
];

// List of pages that should be accessible to all either authenticated or not
export const noAuthRoutes = [
  "/outstanding-invoice-payment",
  "/address-selection",
  "/purchase-cart",
  "/purchase-successful",
  "/number-selection",
  "/reset-password",
  "verify-email",
  "verify-email/existing",
  "/verify-email/new",
  "/welcome",
  "/complete-signup",
  "/verify-signin-token",
  "/email-verification",
  "/verify-nin",
  "/payment-successful",
  "/additional-slot",
  "/pending-invites",
  "/address-purchase",
];

// These are known routes that are public and do not require user details or trigger a redirect if already authenticated
export const publicRoutes = [
  "/payment-successful",
  "/additional-slot",
  "/pending-invites",
  "/address-purchase",
];

export const businessRoles = [
  "CEO (Chief Executive Officer)",
  "CFO (Chief Financial Officer)",
  "COO (Chief Operating Officer)",
  "CMO (Chief Marketing Officer)",
  "CTO (Chief Technology Officer)",
  "CIO (Chief Information Officer)",
  "CHRO (Chief Human Resources Officer)",
  "CCO (Chief Communications Officer)",
  "CDO (Chief Data Officer)",
  "CSO (Chief Strategy Officer)",
  "CLO (Chief Legal Officer)",
  "CRO (Chief Risk Officer)",
  "President",
  "Vice President",
  "Director",
  "Manager",
  "Supervisor",
  "Team Leader",
  "Project Manager",
  "Product Manager",
  "Program Manager",
  "Business Analyst",
  "Financial Analyst",
  "Data Analyst",
  "Marketing Manager",
  "Sales Manager",
  "Customer Success Manager",
  "Operations Manager",
  "HR Manager",
  "Recruitment Specialist",
  "Training and Development Manager",
  "Talent Acquisition Manager",
  "Compensation and Benefits Specialist",
  "Diversity and Inclusion Manager",
  "Employee Relations Manager",
  "Learning and Development Specialist",
  "Organizational Development Specialist",
  "Talent Management Specialist",
  "Performance Management Specialist",
  "Change Management Specialist",
  "Employee Engagement Specialist",
  "Internal Communications Specialist",
  "Public Relations Manager",
  "Media Relations Specialist",
  "Social Media Manager",
  "Content Manager",
  "Brand Manager",
  "Digital Marketing Specialist",
  "SEO Specialist",
  "SEM Specialist",
  "PPC Specialist",
  "Email Marketing Specialist",
  "Web Developer",
  "Software Engineer",
  "Systems Administrator",
  "Network Engineer",
  "Database Administrator",
  "IT Support Specialist",
  "Cybersecurity Analyst",
  "Cloud Architect",
  "UX/UI Designer",
  "Graphic Designer",
  "Content Writer",
  "Copywriter",
  "Technical Writer",
  "Editor",
  "Proofreader",
  "Researcher",
  "Market Research Analyst",
  "Sales Representative",
  "Account Manager",
  "Customer Support Specialist",
  "Client Success Manager",
  "Business Development Manager",
  "Strategic Partnerships Manager",
  "Procurement Specialist",
  "Supply Chain Manager",
  "Logistics Coordinator",
  "Warehouse Manager",
  "Quality Assurance Specialist",
  "Regulatory Compliance Specialist",
  "Environmental Health and Safety Manager",
  "Risk Management Specialist",
  "Legal Counsel",
  "Contracts Manager",
  "Corporate Secretary",
  "General Counsel",
  "Compliance Officer",
  "Ethics Officer",
  "Internal Auditor",
  "External Auditor",
  "Financial Controller",
  "Tax Manager",
  "Treasury Analyst",
  "Budget Analyst",
  "Credit Analyst",
  "Financial Planner",
  "Investment Analyst",
  "Portfolio Manager",
  "Wealth Manager",
  "Insurance Specialist",
  "Actuary",
  "Underwriter",
  "Claims Adjuster",
  "Mortgage Broker",
  "Real Estate Agent",
  "Property Manager",
  "Facilities Manager",
  "Construction Manager",
  "Architect",
  "Civil Engineer",
  "Mechanical Engineer",
  "Electrical Engineer",
  "Project Engineer",
  "Research and Development Manager",
  "Innovation Manager",
  "Product Development Specialist",
  "Manufacturing Engineer",
  "Production Manager",
  "Quality Control Manager",
  "Process Improvement Specialist",
  "Six Sigma Black Belt",
  "Lean Manufacturing Specialist",
  "Environmental Engineer",
  "Sustainability Manager",
  "Health and Safety Officer",
  "Occupational Therapist",
  "Psychologist",
  "Social Worker",
  "Counselor",
  "Life Coach",
  "Nurse",
  "Physician",
  "Pharmacist",
  "Medical Technologist",
  "Epidemiologist",
  "Health Educator",
  "Nutritionist",
  "Fitness Trainer",
  "Wellness Coach",
  "Sports Psychologist",
  "Recreation Coordinator",
  "Event Planner",
  "Hospitality Manager",
  "Restaurant Manager",
  "Food and Beverage Director",
  "Catering Manager",
  "Tourism Coordinator",
  "Travel Agent",
  "Concierge",
  "Accountant",
];

export const businessIndustries = [
  "Accounting",
  "Administration & Office Support",
  "Advertising, Arts & Media",
  "Banking & Financial Services",
  "Call Centre & Customer Service",
  "Community Services & Development",
  "Construction",
  "Consulting & Strategy",
  "Design & Architecture",
  "Education & Training",
  "Engineering",
  "Farming, Animals & Conservation",
  "Government & Defence",
  "Healthcare & Medical",
  "Hospitality & Tourism",
  "Human Resources & Recruitment",
  "Information & Communication Technology",
  "Insurance & Superannuation",
  "Legal",
  "Manufacturing, Transport & Logistics",
  "Marketing & Communications",
  "Mining, Resources & Energy",
  "Real Estate & Property",
  "Retail & Consumer Products",
  "Sales",
  "Science & Technology",
  "Sport & Recreation",
  "Trades & Services",
  "Others",
];

// Address usage options constant
export const ADDRESS_USAGE_OPTIONS = [
  { key: "receiveMail", label: "To receive mail", value: "receive_mail" },
  {
    key: "platformRegistration",
    label: "For platform registration",
    value: "platform_registration",
  },
  { key: "others", label: "Others (please specify)", value: "others" },
] as const;

export const countriesFlags = [
  // { flag: nigerianFlag, country: "Nigeria", countryCode: "NG" },
  // { flag: kenyanFlag, country: "Kenya", countryCode: "KE" },
  { flag: usFlag, country: "United States", countryCode: "US" },
  { flag: ukFlag, country: "United Kingdom", countryCode: "GB" },
  { flag: canadaFlag, country: "Canada", countryCode: "CA" },
];

export const PRODUCTION_HOST = "https://web.pressone.africa";
export const STAGING_HOST = "https://staging--new-pressone-web.netlify.app";

export const BASE_HOST = IS_PROD ? PRODUCTION_HOST : STAGING_HOST;

export const INVITE_PRODUCTION_URL =
  "https://pressone.africa/team-member-onboarding";
export const INVITE_STAGING_URL =
  "https://pressone.africa/team-member-onboarding-staging-copy";

export const INVITE_URL = IS_PROD ? INVITE_PRODUCTION_URL : INVITE_STAGING_URL;

// export const networkLatencyProdUrl = "wss://api.staging.zephyr.pressone.co:443"; // Old
export const networkLatencyProdUrl = "wss://api.zephyr.ng.pressone.co/ws/";
export const networkLatencyStagingUrl = "wss://api.zephyr.ng.pressone.co/ws/";

export const networkLatencyUrl = IS_PROD
  ? networkLatencyProdUrl
  : networkLatencyStagingUrl;

export const INTEGRATION_PLANS_PROD = [21, 25, 26, 32, 33, 31, 34];
export const INTEGRATION_PLANS_STAGING = [5, 7, 17];

// These are plans that have access to integrations
export const INTEGRATION_PLANS_IDS = IS_PROD
  ? INTEGRATION_PLANS_PROD
  : INTEGRATION_PLANS_STAGING;

export const defaultContactState = (): UserContactOutSchema => ({
  call_time: 0,
  name: "",
  number: "",
  user: 0,
  date_created: "",
  email: "",
  company: null,
  job_title: null,
  address: null,
});
